import { lazyIsSharePointLink } from 'owa-sharepoint-link-detector';
import { ORIGINALSRC_ATTTIBUTE_NAME, SHASH_ATTTIBUTE_NAME } from './constants';

export async function isSafeLink(element: HTMLElement): Promise<boolean> {
    const isSharePointLink = await lazyIsSharePointLink.import();
    if (isSharePointLink((<HTMLAnchorElement>element).href)) {
        return false;
    }

    return (
        element.hasAttribute(ORIGINALSRC_ATTTIBUTE_NAME) &&
        element.hasAttribute(SHASH_ATTTIBUTE_NAME)
    );
}
